module.exports = __webpack_public_path__ + "static/media/6day@2x.5beed4b9.png";